import React, { useEffect, useState, createContext, useContext } from 'react';
const TARGET = 100;
const SEED_COUNT = 67;
const STORAGE_KEY = 'masube_waitlist_v1';
interface WaitlistState {
  count: number;
  target: number;
  remaining: number;
  progress: number; // 0-1
  isUnlocked: boolean;
  hasJoined: boolean;
  position: number | null;
  addSignup: () => number; // returns the signup's position
}
const WaitlistContext = createContext<WaitlistState | undefined>(undefined);
export function WaitlistProvider({
  children
}: {
  children: ReactNode;
}) {
  const [count, setCount] = useState(SEED_COUNT);
  const [hasJoined, setHasJoined] = useState(false);
  const [position, setPosition] = useState<number | null>(null);
  // Hydrate from localStorage so the count + joined state feel persistent
  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const saved = JSON.parse(raw);
        if (typeof saved.count === 'number') setCount(saved.count);
        if (typeof saved.hasJoined === 'boolean') setHasJoined(saved.hasJoined);
        if (typeof saved.position === 'number') setPosition(saved.position);
      }
    } catch {

      /* ignore */}
  }, []);
  const persist = (next: {
    count: number;
    hasJoined: boolean;
    position: number | null;
  }) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {

      /* ignore */}
  };
  const addSignup = () => {
    if (hasJoined && position !== null) return position;
    const newCount = Math.min(count + 1, TARGET);
    const newPosition = newCount;
    setCount(newCount);
    setHasJoined(true);
    setPosition(newPosition);
    persist({
      count: newCount,
      hasJoined: true,
      position: newPosition
    });
    return newPosition;
  };
  const remaining = Math.max(TARGET - count, 0);
  const progress = Math.min(count / TARGET, 1);
  const isUnlocked = count >= TARGET;
  return <WaitlistContext.Provider value={{
    count,
    target: TARGET,
    remaining,
    progress,
    isUnlocked,
    hasJoined,
    position,
    addSignup
  }} data-id="element-626">
      
      {children}
    </WaitlistContext.Provider>;
}
export function useWaitlist() {
  const ctx = useContext(WaitlistContext);
  if (ctx === undefined) {
    throw new Error('useWaitlist must be used within a WaitlistProvider');
  }
  return ctx;
}